import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedPhoneNumber from 'I18n/components/FormattedPhoneNumber';
import { Link } from 'foundations-components/transitional/components/Link';
import { useAppSelector } from '../redux';
import { selectSupportEmail, selectSupportPhoneNumber } from '../features/PublicPortalSettings/PublicPortalSettingsSelectors';
import { useIsMobileView } from '../hooks/useWindowSize';
import { jsx as _jsx } from "react/jsx-runtime";
export const Footer = () => {
  const supportEmail = useAppSelector(selectSupportEmail);
  const supportPhoneNumber = useAppSelector(selectSupportPhoneNumber);
  const isMobileView = useIsMobileView();
  const contactUsMessage = (() => {
    if (supportEmail && supportPhoneNumber) {
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "footer.contactUsEmailAndPhone",
        options: {
          supportEmail: /*#__PURE__*/_jsx(Link, {
            href: `mailto:${supportEmail}`,
            children: supportEmail
          }),
          supportPhoneNumber: /*#__PURE__*/_jsx(Link, {
            href: `tel:${supportPhoneNumber}`,
            children: /*#__PURE__*/_jsx(FormattedPhoneNumber, {
              value: supportPhoneNumber
            })
          })
        }
      });
    } else if (supportEmail) {
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "footer.contactUsEmail",
        options: {
          supportEmail: /*#__PURE__*/_jsx(Link, {
            href: `mailto:${supportEmail}`,
            children: supportEmail
          })
        }
      });
    } else if (supportPhoneNumber) {
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "footer.contactUsPhone",
        options: {
          supportPhoneNumber: /*#__PURE__*/_jsx(Link, {
            href: `tel:${supportPhoneNumber}`,
            children: /*#__PURE__*/_jsx(FormattedPhoneNumber, {
              value: supportPhoneNumber
            })
          })
        }
      });
    }
    return null;
  })();
  if (!contactUsMessage) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    justifyContent: "center",
    padding: isMobileView ? '300' : '500',
    backgroundColor: "fill-surface-default",
    borderBlockStartWidth: "100",
    borderBlockStartStyle: "solid",
    borderBlockStartColor: "border-core-subtle",
    children: /*#__PURE__*/_jsx(Text, {
      typography: isMobileView ? 'detail-100' : 'body-100',
      textAlign: "center",
      children: contactUsMessage
    })
  });
};